import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { pageResetMiddleWare, zodOptionalIdArray, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const labPharmaciesRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/pharmacies',
  validateSearch: z.object({
    query: z.string().optional(),
    page: zodPage,
    groupIds: zodOptionalIdArray,
    salesRepIds: zodOptionalIdArray,
    regionalDirectorIds: zodOptionalIdArray,
    filterBy: z.enum(['sponsored', 'all']).default('all'),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() => import('pages/lab/Pharmacies/PharmaciesPage/PharmaciesPage').then((d) => d.Route));
